import React from 'react';
import WebGLContainer from '../components/GameFrame/WebGLContainer';
import OrientationLock from '../components/OrientationLock';
import './GamePage.css';

const GamePage = () => {
  return (
    <OrientationLock>
    <div className="game-page">
        <WebGLContainer />
    </div>
    </OrientationLock>
  );
};

export default GamePage; 